import { useEffect, useState } from 'react';
import { joinWaitlistRest, leaveWaitlistRest } from '@/services/table/tableService';
import { useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import Button from '@/components/new-design/Button';
import { twMerge } from 'tailwind-merge';
import useIsMobileView from '@/hooks/useIsMobileView';

interface ConciergeParams {
  tableId: string;
  userId: string;
  fullTable: boolean;
  waitlist: string[];
}

const ConciergeContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div className="mx-auto w-full max-w-[80%] text-center">
      <div className="flex flex-col gap-2 text-[16px]">{children}</div>
    </div>
  );
};
const ConciergeTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="text-center font-manrope text-sm font-bold leading-[3em] text-white md:text-base">{children}</div>
  );
};
const ConciergeActionsContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="flex items-center justify-center text-[16px]">{children}</div>;
};

const Concierge: React.FC<ConciergeParams> = ({ tableId, userId, fullTable, waitlist }) => {
  const isMobileView = useIsMobileView();
  const [userPosition, setUserPosition] = useState<number | undefined>(waitlist.indexOf(userId) + 1);
  const tableState = useSelector((state: ReducerState) => state.tables?.[tableId]);

  const [disabled, setDisabled] = useState<boolean>(false);

  useEffect(() => {
    setDisabled(false);
  }, [waitlist, fullTable]);

  useEffect(() => {
    setUserPosition(waitlist.indexOf(userId) + 1);
  }, [waitlist, setUserPosition, userId]);

  if (!tableState?.url) {
    // if table is not initialized, we shouldn't show this
    return;
  }

  if (!fullTable && !userPosition) return;

  const leaveWaitlist = async () => {
    setDisabled(true);
    try {
      await leaveWaitlistRest({ tableId, tableUrl: tableState?.url });
    } catch (error) {
      console.log('error', error); // TODO
    }
  };

  if (userPosition)
    return (
      <ConciergeContainer>
        <ConciergeTitle>
          <span>
            You are number <span className="font-black text-ph-primary-violet-lighter">{userPosition}</span> on the
            Waitlist
          </span>
        </ConciergeTitle>
        <ConciergeActionsContainer>
          <Button
            disabled={disabled}
            onClick={leaveWaitlist}
            type="button"
            className="gap-3 rounded-[10px] bg-ph-purple p-3 px-5 text-center font-bold leading-5 text-white"
          >
            Leave Waitlist
          </Button>
        </ConciergeActionsContainer>
      </ConciergeContainer>
    );

  const joinWaitlist = async () => {
    setDisabled(true);
    try {
      await joinWaitlistRest({ tableId, tableUrl: tableState?.url });
    } catch (error) {
      console.log('error', error); // TODO
    }
  };
  return (
    <ConciergeContainer>
      <ConciergeTitle>
        {waitlist?.length > 0 ||
          (true && (
            <span>
              {waitlist.length === 1 ? 'There is ' : 'There are '}
              <span className="font-black text-ph-primary-violet-lighter">{waitlist.length}</span>{' '}
              {waitlist.length === 1 ? 'person ' : 'people '}
              on the Waitlist
            </span>
          ))}
      </ConciergeTitle>
      <ConciergeActionsContainer>
        <Button
          disabled={true}
          onClick={joinWaitlist}
          type="button"
          className="gap-3 rounded-[10px] bg-ph-purple p-3 px-5 text-center font-bold leading-5 text-white"
        >
          Join Waitlist
        </Button>
      </ConciergeActionsContainer>
    </ConciergeContainer>
  );
};

export default Concierge;
